/* FIXME: This component was added for the useDashboardReskinExperiment to look as sunrise but needs to be updated to use the new Sunrise components once they're implemented */
import type { ComponentProps, ForwardedRef } from 'react';

import { forwardRef } from '@change-corgi/core/react/core';
import { Radio } from '@change-corgi/design-system-legacy/components/forms';
import { Box } from '@change-corgi/design-system-legacy/layout';

/* eslint-disable @typescript-eslint/naming-convention */
const radioCardStyles = {
	'&:hover': {
		boxShadow: '0px 6px 12px 0px rgba(0, 0, 0, 0.25)',
		borderRadius: '0.5rem',
	},
	'& > label': {
		borderRadius: '0.5rem',
		borderWidth: 1,
		borderColor: 'var(--background-overlay-color)',
		borderStyle: 'solid',
		backgroundColor: 'var(--background-overlay-color)',
		display: 'flex',
		flexDirection: 'column-reverse',
		alignItems: 'center',
		'& > input[type="radio"]': {
			marginTop: 6,
			marginBottom: 18,
			marginRight: 0,
		},
	},
	'& > label:focus-within, & > label[data-selected="true"]': {
		outlineRadius: '0.5rem',
		outlineWidth: 3,
		outlineStyle: 'solid',
		outlineColor: '#4771FF',
	},
	'& > label > input[type="radio"]:focus': {
		outline: 'none',
	},
	'& > label > input[type="radio"]:checked': {
		accentColor: '#4771FF',
	},
	'& > label > .boolean-input-label': {
		overflow: 'hidden',
		borderTopRightRadius: '0.5rem',
		borderTopLeftRadius: '0.5rem',
		backgroundColor: 'var(--fill-inverse-strong-color)',
	},
} as const;
/* eslint-enable @typescript-eslint/naming-convention */

function RadioCardInner(
	props: ComponentProps<typeof Radio> & { className?: string },
	ref: ForwardedRef<HTMLInputElement>,
): JSX.Element {
	const { className, ...rest } = props;
	return (
		<Box className={className} sx={{ ...radioCardStyles }}>
			<Radio {...rest} ref={ref} />
		</Box>
	);
}

export const RadioCard = forwardRef(RadioCardInner);
